import { createSlice } from "@reduxjs/toolkit";
import { ReviewLink, User } from "./usersTypes";
import { PaymentCard } from "../card/cardTypes";

interface UserState {
  reviewModal: boolean;
  paymentModal: boolean;
  profileModal: boolean;
  reviewModalData: ReviewLink | null;
  paymentModalData: PaymentCard | null;
  profileModalData: User | null;
}

const initialState: UserState = {
  reviewModal: false,
  paymentModal: false,
  profileModal: false,
  reviewModalData: null,
  paymentModalData: null,
  profileModalData: null,
};

const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    openPaymentModal: (state) => {
      state.paymentModal = true;
    },
    openReviewModal: (state, { payload }) => {
      state.reviewModal = true;
      state.reviewModalData = payload;
    },
    openProfileModal: (state) => {
      state.profileModal = true;
    },
    closeModals: (state) => {
      state.reviewModal = false;
      state.paymentModal = false;
      state.profileModal = false;
      state.reviewModalData = null;
      state.paymentModalData = null;
      state.profileModalData = null;
    },
  },
});

export const {
  openPaymentModal,
  openProfileModal,
  openReviewModal,
  closeModals,
} = userSlice.actions;
export default userSlice.reducer;
